import cx from 'classnames';
import { Field, getIn } from 'formik';
import React, { FunctionComponent } from 'react';
import FormField from './FormField';
import Label from './Label';

type Props = {
    disabled?: boolean;
    errors: any;
    label?: string;
    name: string;
    placeholder?: string;
    touched: any;
    type?: string;
    values: any;
    width?: number;
}

const TextField: FunctionComponent<Props> = ({disabled, label, name, placeholder, type = 'text', width, values, errors, touched}) => {
    const value = getIn(values, name);
	const error = getIn(errors, name);
    const isTouched = getIn(touched, name);

    return (
        <FormField width={width}>
            {label && <Label name={name} text={label} />}
            <Field
                autoComplete="off"
                className={cx('form-control', { 'is-invalid': error && isTouched }, { 'is-valid': !error && isTouched })}
                disabled={disabled}
                id={name}
                name={name}
                placeholder={placeholder}
                type={type}
                value={value}
            />
            {error && isTouched && <div className="field-error text-danger">{error}</div>}
        </FormField>
    )
}

export default TextField
